var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTostCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1523 2.81836L8.8457 7.125L13.1523 11.4727C13.6855 11.9648 13.6855 12.8262 13.1523 13.3184C12.6602 13.8516 11.7988 13.8516 11.3066 13.3184L7 9.01172L2.65234 13.3184C2.16016 13.8516 1.29883 13.8516 0.806641 13.3184C0.273438 12.8262 0.273438 11.9648 0.806641 11.4727L5.11328 7.125L0.806641 2.81836C0.273438 2.32617 0.273438 1.46484 0.806641 0.972656C1.29883 0.439453 2.16016 0.439453 2.65234 0.972656L7 5.2793L11.3066 0.972656C11.7988 0.439453 12.6602 0.439453 13.1523 0.972656C13.6855 1.46484 13.6855 2.32617 13.1523 2.81836Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTostCloseIcon);
export default __webpack_public_path__ + "static/media/tostCloseIcon.7ad975f61424bbefdb7d20acaad12923.svg";
export { ForwardRef as ReactComponent };